(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-row"] && !Shopify.designMode) return;
  try {
    
  function initFeatureRowVideos(root) {
    root.querySelectorAll('.feature-row__product-video').forEach(function(video) {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            video.muted = true;
            video.play().catch(function() {});
          }
        });
      }, { threshold: 0.5 });
      observer.observe(video);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initFeatureRowVideos(document); });
  } else {
    initFeatureRowVideos(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initFeatureRowVideos(event.target); });

  } catch(e) { console.error(e); }
})();
})();
